"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Hint = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M18.016,11.9997 L18.016,10.9997 L20.016,10.9997 L20.016,11.9997 L18.016,11.9997 Z M10.985,4.9997 L10.985,2.9997 L11.985,2.9997 L11.985,4.9997 L10.985,4.9997 Z M4,12.001 L4,11 L6,11 L6,12.001 L4,12.001 Z M5,5.70781389 L5.70781389,5 L7.12202745,6.41421356 L6.41421356,7.12202745 L5,5.70781389 Z M17.6017864,7.12202745 L16.8939725,6.41421356 L18.3081861,5 L19.016,5.70781389 L17.6017864,7.12202745 Z M11.9842,6.9999 C14.1895333,6.9999 15.9842,8.79456667 15.9842,10.9999 C15.9842,12.3776778 15.0005493,13.9960327 13.9992676,14.5 L14.008842,17.0307987 C14.0109172,18.0280521 13.2214864,18.9786987 11.993042,18.9786987 C10.7645975,18.9786987 10.008842,18.0306767 10.008842,17.0307987 L10,14.5 C9.01538086,13.9793701 7.9842,12.3794556 7.9842,10.9999 C7.9842,8.79456667 9.77886667,6.9999 11.9842,6.9999 Z M13,17.1676025 L12.9842,14.9999 L10.9855324,14.9999 L11,17.1676025 C11,17.7192348 11.5174479,18.0044759 12.0158,18.0008138 C12.5141521,17.9971517 12.9986676,17.7192348 13,17.1676025 Z M11.9842,7.9999 C10.3299143,7.9999 8.9842,9.34561429 8.9842,10.9999 C8.9842,11.8390429 9.33305714,12.5941857 9.89105714,13.1367571 C10.1267714,13.3656143 10.4473429,13.4856143 10.6247714,13.7676143 C10.6573429,13.8190429 10.6770571,13.9039 10.7002,13.9999 L13.2802,13.9999 C13.2930571,13.8979 13.3136286,13.8070429 13.3470571,13.7539 C13.5193429,13.4804714 13.8270571,13.3750429 14.0584857,13.1547571 C14.6276286,12.6113286 14.9842,11.8484714 14.9842,10.9999 C14.9842,9.34561429 13.6384857,7.9999 11.9842,7.9999 Z" })));
};
Hint.displayName = 'Hint';
exports.default = Hint;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Hint.js.map